import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const fadeIn = useFadeIn();
  return <section className="py-16 px-4 bg-gray-50" data-id="element-228">
      <div className="max-w-3xl mx-auto" data-id="element-229">
        <div ref={fadeIn.ref} className={`text-center ${fadeIn.className}`} data-id="element-230">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-10" data-id="element-231">
            💖 Por eso creamos el Pack 100 Citas Familiares
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-dashed border-red-200 mb-12" data-id="element-232">
            <ul className="text-left space-y-6 text-lg text-gray-700 max-w-2xl mx-auto font-medium" data-id="element-233">
              <li className="flex items-start gap-4" data-id="element-234">
                <span className="text-3xl" data-id="element-235">📚</span>
                <p data-id="element-236">
                  <span className="font-bold text-gray-900" data-id="element-237">
                    4 libros digitales llenos de conexión
                  </span>{' '}
                  — cada uno pensado para fortalecer la relación entre padres e
                  hijos.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-238">
                <span className="text-3xl" data-id="element-239">🎉</span>
                <p data-id="element-240">
                  <span className="font-bold text-gray-900" data-id="element-241">
                    Adiós al aburrimiento
                  </span>
                  , con actividades divertidas, simples y económicas para
                  disfrutar en cualquier momento.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-242">
                <span className="text-3xl" data-id="element-243">🗝️</span>
                <p data-id="element-244">
                  <span className="font-bold text-gray-900" data-id="element-245">
                    Juegos secretos
                  </span>{' '}
                  que te ayudan a descubrir lo que tus hijos sienten, piensan y
                  sueñan, mientras se divierten juntos.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-246">
                <span className="text-3xl" data-id="element-247">💌</span>
                <p data-id="element-248">
                  <span className="font-bold text-gray-900" data-id="element-249">
                    30 frases y actividades especiales
                  </span>{' '}
                  para que tus hijos nunca olviden cuánto los amás y lo
                  importante que son para vos.
                </p>
              </li>
              <li className="flex items-start gap-4 bg-yellow-50 p-4 rounded-xl border border-yellow-200" data-id="element-250">
                <span className="text-3xl" data-id="element-251">🎁</span>
                <p data-id="element-252">
                  <span className="font-bold text-gray-900" data-id="element-253">
                    Bonos exclusivos
                  </span>{' '}
                  inspirados en el universo de 100 Citas, con ideas adicionales
                  y retos semanales para mantener viva la conexión familiar.
                </p>
              </li>
            </ul>
          </div>

          <div className="max-w-md mx-auto" data-id="element-254">
            <CTAButton text="👉 QUIERO EL PACK 100 CITAS AHORA" data-id="element-255" />
          </div>
        </div>
      </div>
    </section>;
}